import { render, staticRenderFns } from "./botsTabs.vue?vue&type=template&id=30a06846&scoped=true&"
import script from "./botsTabs.vue?vue&type=script&lang=js&"
export * from "./botsTabs.vue?vue&type=script&lang=js&"
import style0 from "./botsTabs.vue?vue&type=style&index=0&id=30a06846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a06846",
  null
  
)

export default component.exports